import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { withDefaults } from "vue";

interface IVButtonProps {
  color?: string;
  label?: string;
  icon?: string;
  iconRight?: string;
  size?: "xs" | "sm" | "md" | "lg" | "xl";
  textColor?: string;
  flat?: boolean;
  to?: string;
  customStyle?: unknown;
  disabled?: boolean;
  className?: string;
  outline?: boolean;
  padding?: string;
  target?: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'VButton',
  props: {
    color: { default: "primary" },
    label: { default: undefined },
    icon: { default: undefined },
    iconRight: { default: undefined },
    size: { default: "md" },
    textColor: {},
    flat: { type: Boolean },
    to: {},
    customStyle: { default: undefined },
    disabled: { type: Boolean },
    className: {},
    outline: { type: Boolean },
    padding: { default: undefined },
    target: { default: undefined }
  },
  emits: ["click"],
  setup(__props: any, { emit: __emit }) {



const emit = __emit;

const handleClick = () => {
  emit("click");
};

return (_ctx: any,_cache: any) => {
  const _component_q_btn = _resolveComponent("q-btn")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_q_btn, {
      outline: _ctx.outline,
      color: _ctx.color,
      padding: _ctx.padding,
      to: _ctx.to,
      icon: _ctx.icon,
      target: _ctx.target,
      flat: _ctx.flat,
      "icon-right": _ctx.iconRight,
      label: _ctx.label,
      size: _ctx.size,
      textColor: _ctx.textColor,
      style: _normalizeStyle(_ctx.customStyle),
      disable: _ctx.disabled,
      class: _normalizeClass(_ctx.className),
      onClick: handleClick
    }, {
      default: _withCtx(() => [
        _renderSlot(_ctx.$slots, "default")
      ]),
      _: 3
    }, 8, ["outline", "color", "padding", "to", "icon", "target", "flat", "icon-right", "label", "size", "textColor", "style", "disable", "class"])
  ]))
}
}

})